var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('level-left',{staticClass:"delete-box"},[_vm._t("default"),_c('p',{staticClass:"level-item"},[_vm._v(_vm._s(_vm.text))]),_c('loader',{staticClass:"level-item",attrs:{"showLoader":_vm.showLoader}},[_vm._v(_vm._s(_vm.loaderText))])],2)}
var staticRenderFns = []

export { render, staticRenderFns }